import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

// ---------Shared--------------------------------------------
import { LoginService } from '../../shared-modules/login/login.service';
import { UserService } from '../../shared-components/user/user.service';
import { Student360Service } from '../student360.service';
import { StudentService } from '../../shared-components/student/student.service';
import { YearService } from '../../shared-components/year/year.service';
import { LoginSettings } from '../../shared-modules/login/loginSetting.model';
import { Student } from '../../shared-components/student/student.model';
import { MealServiceService } from './meal-service.service';
import { MealService, MealServiceFilter, LunchMealChoice, MonthlyLunchMenuChoices } from './meal-service.model';
import { MealServiceFilterPipe } from './meal-service-filter.pipe';
import { LunchMenuChoicesComponent } from './lunch-menu-choices/lunch-menu-choices.component';
// -------Angular Material------------------------------------
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { ChargesAndDepositsComponent } from './charges-and-deposits/charges-and-deposits.component';
import { MonthlyLunchMenuComponent } from './monthly-lunch-menu/monthly-lunch-menu.component';
import { OnlinePaymentConfiguration } from '../online-payment/models/online-payment-config.model';
import { Year } from '../../shared-components/year/year.model';
import { Router, NavigationExtras } from '@angular/router';
import { Portal } from '../../shared-components/portal.model';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@AutoUnsubscribe()
@Component({
    selector: 'app-meal-service',
    templateUrl: './meal-service.component.html',
    animations: [detailExpand],
    providers: [DatePipe]
})
export class MealServiceComponent implements OnInit, OnDestroy {

    // -----------Grid functionality---------------------------------
    selectionIndex = 0;

    // ------------Element references--------------------------------
    @ViewChild('tabContent', { read: ElementRef }) tabContentRef: ElementRef;
    // ------------Selection/Flags-----------------------------------
    userType: number;
    isBusy = false;
    currentUrl: string;
    showPassword = false;
    // ------------------------------------------------------------
    LoginSettings: LoginSettings;
    selectedStudent: Student;
    selectedStudentSubscription: Subscription;
    student360YearSubscription: Subscription;
    studentEnrollment = this.studentService.studentEnrollment;
    currentDate: Date = new Date();
    selectedStudentId: number;
    parentPortalSubscription: Subscription;
    staffAssignedPortalsSubscription: Subscription;
    // ----------Angular Material------------------------------------
    clearFilterEvent = new EventEmitter<any>();
    classFilter = new LunchMealChoice();
    pusherFilter: LunchMealChoice;
    @ViewChild(ChargesAndDepositsComponent) byViewChargesRef: ChargesAndDepositsComponent;
    @ViewChild(MonthlyLunchMenuComponent) byViewMonthlyRef: MonthlyLunchMenuComponent;

    // ------------Meal Service Data---------------------------
    tabNames: string[] = [];
    mealService: MealService[];
    lunchMealChoice: LunchMealChoice[];
    selectedChoice: MonthlyLunchMenuChoices[] = [];
    studentMonthlyLunchMenuChoice: LunchMealChoice[] = [];
    myClasses: LunchMealChoice[];
    totalRollOver = 0.00;
    totalDeposit = 0.00;
    totalPurchases = 0.00;
    totalBalance = 0.00;
    parentPortal: Portal[];
    lunchPin = '';
    // ------------Selection/Flags-----------------------------------
    selected = '0';
    showMontlyLunchMenuGrid: boolean;
    lunchMealChoicesDialogRef: MatDialogRef<LunchMenuChoicesComponent>;

    // ------------Filter-----------------------------------
    showFilterEvent = new EventEmitter();
    showFilter = false;
    mealServiceFilter = new MealService();
    filterFromDate: Date;
    filterToDate: Date;
    filtered = false;
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    parentPortalShowOnlinePayment: boolean;
    student360Year: Year;
    // ----------------- Monthly Lunch Menu -------------------
    selectedMonth: string;
    selectedYear: number;
    monthLabels: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    DisabledNxtBtn: boolean;
    DisabledPrvBtn: boolean;
    loadStudentInfoCall = false

    constructor(
        private loginService: LoginService,
        private userService: UserService,
        private studentService: StudentService,
        private yearService: YearService,
        private mealServiceService: MealServiceService,
        private parentPortalService: Student360Service,
        private mealServiceFilterPipe: MealServiceFilterPipe,
        private location: Location,
        private router: Router,
        private classroom360Service: Classroom360Service,
        public changeDetector: ChangeDetectorRef,
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                if (studentId > 0) {
                    this.loadStudentInfoCall = true;
                    this.loadStudentInfo(studentId);
                }
            });
        if (this.userService.userType == 1) {
            this.staffAssignedPortalsSubscription = this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(data => {
                this.parentPortal = data;
            });
        }
        else {
            this.parentPortalSubscription = this.parentPortalService.observableParentAssignedPortalsStream$.subscribe(portal => {
                this.parentPortal = portal;
            });
        }
        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            student360Year => {
                this.student360Year = student360Year;
                this.loadStudentInfo(this.selectedStudent.Id);
            }
        );

        this.LoginSettings = this.loginService.LoginSettings;
        this.userType = this.userService.userType;
        this.parentPortalShowOnlinePayment = this.LoginSettings.ParentPortalShowOnlinePayment;
        this.student360Year = this.yearService.student360Year;
        this.currentUrl = this.location.path();
        this.selectedStudentId = this.studentService.selectedStudent.Id;

        if (this.userType == 1) {
            if (this.parentPortal.filter(o => o.PortalName == 'Meal Service' && o.Disabled == false && o.ParentModule == '/student360').length > 0) {
                this.tabNames.push(marker('charges and deposits').toString()); // mark tab name for translation
            }
        }
        else {
            if (this.parentPortal.filter(o => o.PortalName == 'Meal Service' && o.Disabled == false).length > 0) {
                this.tabNames.push(marker('charges and deposits').toString());  // mark tab name for translation
            }
        }

        if (this.parentPortal.filter(o => o.PortalName == 'Monthly Lunch Menu' && o.Disabled == false).length > 0) {
            this.tabNames.push(marker('monthly lunch menu').toString()); // mark tab name for translation
        }

        this.selectedMonth = this.monthLabels[this.currentDate.getMonth()];
        this.selectedYear = this.currentDate.getFullYear();
    }

    ngOnInit() {
        if (this.currentUrl.indexOf('?') > 0) {
            const url = this.router.url.substring(0, this.router.url.indexOf('?'));
            this.currentUrl = url;
        }
        if (this.currentUrl == '/student360/lunchMealPlanner') {
            this.mealServiceService.selectionIndex = 1;
            this.selectionIndex = 1;
        }
        else if (this.currentUrl == '/student360/mealService') {
            this.mealServiceService.selectionIndex = 0;
            this.selectionIndex = 0;
        }
        else if (this.mealServiceService.selectionIndex) {
            this.selectionIndex = this.mealServiceService.selectionIndex;
        }

        if (this.userService.userType == 2) {
            this.studentService.getOnlinePaymentConfiguration().subscribe(result => {
                this.onlinePaymentConfiguration = result;
            });
        }
        if (this.loadStudentInfoCall == false) {
            this.loadStudentInfo(this.studentService.selectedStudent.Id);
        }
        this.loadStudentInfoCall = false;
    }

    ngOnDestroy() {
        this.student360YearSubscription.unsubscribe();
        this.selectedStudentSubscription.unsubscribe();
    }

    // ------------ Meal Service Data ---------------------------
    loadStudentInfo(studentId: number) {
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.studentEnrollment = this.studentService.studentEnrollment;
        this.getMealService();
        this.getMothlyLunchMenu();
    }

    getMealService() {
        this.isBusy = true;
        this.mealServiceService.getMealService(this.selectedStudent.Id, this.yearService.student360Year.Id, this.studentEnrollment.SiteYearId).subscribe(data => {
            this.mealService = data;
            this.loadMealService();
        });
    }

    getLunchPin() {
        this.mealServiceService.getLunchPinForStudentAndStaff(this.selectedStudent.Id, this.studentEnrollment.SchoolId).subscribe(data => {
            this.lunchPin = data;
        });
    }

    loadMealService() {
        this.filterChange();
        this.getCalculationSummary();
        this.getLunchPin();
        this.isBusy = false;
        if (this.byViewChargesRef != null) {
            this.byViewChargesRef.refreshGrid(this.mealService, this.lunchMealChoice);
        }
    }

    getMothlyLunchMenu() {
        this.isBusy = true;
        this.mealServiceService.getMonthlyLunchMenu(this.selectedStudent.Id, this.studentEnrollment.SiteYearId, this.yearService.student360Year.StartDate, this.yearService.student360Year.EndDate).subscribe(data => {
            this.lunchMealChoice = data;
            if (this.byViewMonthlyRef != null) {
                this.byViewMonthlyRef.refreshGrid(this.lunchMealChoice, this.currentDate);
            }
        });
    }

    loadMealMonthlyLunchMenu(): void {
        this.byViewMonthlyRef.angularMatDataMonthlyLunchMenu.data = this.lunchMealChoice;
        this.isBusy = false;
    }

    selectionChange(selectionIndex: number) {
        this.selectionIndex = selectionIndex;

        if (this.selectionIndex == 1) {
            setTimeout(() => {
                this.byViewMonthlyRef.refreshGrid(this.lunchMealChoice, this.currentDate);
            }, 0);
        }
        else {
            setTimeout(() => {
                this.byViewChargesRef.refreshGrid(this.mealService, this.lunchMealChoice);
            }, 0);
        }
    }

    getCalculationSummary() {
        this.totalBalance = 0.00;
        this.totalDeposit = 0.00;
        this.totalRollOver = 0.00;
        this.totalPurchases = 0.00;

        if (this.mealService != null && this.mealService.length > 0) {
            this.mealService.forEach(function (obj) {
                if (obj.MealServiceDetailItems != null && obj.MealServiceDetailItems.length > 0) {
                    const mealDetail = obj.MealServiceDetailItems;
                    for (let j = 0; j < mealDetail.length; j++) {
                        if (mealDetail[j] != null) {
                            if (mealDetail[j].TransactionType == 'Deposit') {
                                this.totalDeposit = this.totalDeposit + mealDetail[j].fltAmount;
                            }
                            else if (mealDetail[j].TransactionType == 'Refund') {
                                this.totalDeposit = this.totalDeposit - mealDetail[j].fltAmount;
                            }
                            else if (mealDetail[j].TransactionType == 'Rollover') {
                                this.totalRollOver = this.totalRollOver + mealDetail[j].fltAmount;
                            }
                            else if (mealDetail[j].TransactionType == 'Charge') {
                                this.totalPurchases = this.totalPurchases + mealDetail[j].fltAmount;
                            }
                            else if (mealDetail[j].TransactionType == 'Void') {
                                this.totalPurchases = this.totalPurchases - mealDetail[j].fltAmount;
                            }
                            else if (mealDetail[j].TransactionType == 'Online') {
                                this.totalDeposit = this.totalDeposit + mealDetail[j].fltAmount;
                            }
                        }
                    }
                }
                else {
                    if (parseFloat(obj.Deposits) != 0) {
                        this.totalDeposit = this.totalDeposit + parseFloat(obj.Deposits);
                    }
                    else if (parseFloat(obj.TotalPurchases) != 0) {
                        this.totalPurchases = this.totalPurchases + parseFloat(obj.TotalPurchases);
                    }
                }
                this.totalBalance = this.totalRollOver + this.totalDeposit - this.totalPurchases;
            }.bind(this));
        }
    }

    changeDate = function (direction: string) {
        const monthNum = (direction == 'next') ? this.currentDate.getMonth() + 1 : this.currentDate.getMonth() - 1;
        if (direction == 'today') {
            this.currentDate = new Date();
        }
        else {
            this.currentDate = new Date(this.currentDate.getFullYear(), monthNum);
        }
        this.yearStartDate = new Date(new Date(this.yearService.student360Year.StartDate).getFullYear(), new Date(this.yearService.student360Year.StartDate).getMonth());
        this.yearEndDate = new Date(new Date(this.yearService.student360Year.EndDate).getFullYear(), new Date(this.yearService.student360Year.EndDate).getMonth());

        switch (this.nearestDateCheck(this.yearStartDate, this.yearEndDate, this.currentDate)) {
            case 1:
                this.DisabledNxtBtn = true;
                this.DisabledPrvBtn = false;
                break;
            case 2:
                this.DisabledNxtBtn = false;
                this.DisabledPrvBtn = true;
                break;
            default:
                this.DisabledNxtBtn = false;
                this.DisabledPrvBtn = false;
                break;
        }
        this.selectedMonth = this.monthLabels[this.currentDate.getMonth()];
        this.selectedYear = this.currentDate.getFullYear();

        this.byViewMonthlyRef.refreshGrid(this.lunchMealChoice, this.currentDate);
    };

    nearestDateCheck(fromDate: Date, toDate: Date, currentDate: Date): number {
        if (new Date(currentDate) >= new Date(toDate)) {
            return 1;
        }
        else if (new Date(currentDate) <= new Date(fromDate)) {
            return 2;
        }
        return 0;
    }

    // -----------Toggle Rows Logic--------------
    expandAll(expand: boolean) {
        this.byViewChargesRef.expandAll(expand);
    }

    // -----------Filter Logic--------------
    showFilterClick() {
        this.showFilter = !this.showFilter;
    }

    filterChange() {
        this.filterFromDate = this.mealServiceFilter.FromDate;
        this.filterToDate = this.mealServiceFilter.ToDate;
        if (this.byViewChargesRef != null) {
            this.byViewChargesRef.angularMatData.data = this.mealServiceFilterPipe.transform(this.mealService, this.filterFromDate, this.filterToDate);
        }
        this.filtered = this.classesFiltered();
    }

    classesFiltered() {
        this.filterFromDate = this.mealServiceFilter.FromDate;
        this.filterToDate = this.mealServiceFilter.ToDate;
        if ((this.filterFromDate != undefined && this.filterFromDate != null) || (this.filterToDate != undefined && this.filterToDate != null)) {
            return true;
        } else {
            return false;
        }
    }

    clearFilter() {
        if (this.byViewMonthlyRef != undefined) {
            this.byViewMonthlyRef.angularMatDataMonthlyLunchMenu.removeAllFilters();
        }
        else if (this.byViewChargesRef != undefined) {
            this.clearFilterEvent.emit();
            this.byViewChargesRef.angularMatData.removeAllFilters();
        }
    }

    isFiltered(): boolean {
        let filtered: boolean;

        if (this.byViewMonthlyRef != undefined) {
            if (this.byViewMonthlyRef.angularMatDataMonthlyLunchMenu.isFiltered()) {
                filtered = true;
            }
        }
        else if (this.byViewChargesRef != undefined) {
            if (this.byViewChargesRef.angularMatData.isFiltered()) {
                filtered = true;
            }
        }
        return filtered;
    }

    onlinePaymentClick() {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'selectedView': 2
            }
        };
        this.router.navigate(['/student360/onlinePayment'], navigationExtras);
    }

    viewPassword(showPassword) {
        this.showPassword = showPassword;
    }
}
